export default __webpack_public_path__ + "static/media/3 Success Reports.633aa348.png";